import { FC, type CSSProperties } from "react";
import { Tabs, Tab } from "@rothoblaas/design-system";
import { resolveAccentColor } from "../../../constants/colors";
import useI18n from "../../../hooks/useTranslations";
import { ModuleSettings } from "../../../http/types/modules";
import AdminConnectorsTabs from "./admin/AdminConnectorsTabs";
import AdminFasteningTypes from "./admin/AdminFasteningTypes";
import AdminGroovingTypes from "./admin/AdminGroovingTypes";
import AdminScrewsTabs from "./admin/AdminScrewsTabs";
import AdminSecondaryItems from "./admin/AdminSecondaryItems";
import AdminSubstructuresTabs from "./admin/AdminSubstructuresTabs";
import AdminSupportsTabs from "./admin/AdminSupportsTabs";

interface DeckDesignerAdminSettingsProps {
  moduleData: ModuleSettings;
}

const DeckDesignerAdminSettings: FC<DeckDesignerAdminSettingsProps> = ({ moduleData }) => {
  const i18n = useI18n();

  const tabs: Tab[] = [
    { title: i18n.translation.deckDesignerModule.screws.plural, hasSubTabs: true },
    { title: i18n.translation.deckDesignerModule.connectors.plural, hasSubTabs: true },
    { title: i18n.translation.deckDesignerModule.substructures.plural, hasSubTabs: true },
    { title: i18n.translation.deckDesignerModule.supports.plural, hasSubTabs: true },
    { title: i18n.translation.deckDesignerModule.fasteningTypes.plural },
    { title: i18n.translation.deckDesignerModule.groovingTypes.plural },
    { title: i18n.translation.deckDesignerModule.secondaryItems.plural },
  ];

  return (
    <div style={{ "--accent-base": resolveAccentColor(moduleData.category?.color) } as CSSProperties}>
      <Tabs
        urlParameter="l_tab"
        tabs={tabs}
        contents={[
          <AdminScrewsTabs />,
          <AdminConnectorsTabs />,
          <AdminSubstructuresTabs />,
          <AdminSupportsTabs />,
          <AdminFasteningTypes />,
          <AdminGroovingTypes />,
          <AdminSecondaryItems />,
        ]}
      />
    </div>
  );
};

export default DeckDesignerAdminSettings;
